// extracted by mini-css-extract-plugin
export default {"stepPrefix":"EUGGS4","stepLabel":"wTKUBI"};